import {
  attributeValueCreate,
  attributeValueUpdate,
  attributeValueDelete
} from "@/api/attributeValue.api";

import {
  ATTR_VALUE_CREATE,
  ATTR_VALUE_UPDATE,
  ATTR_VALUE_DELETE
} from "../type";

const state = {};

const getters = {};

const actions = {
  async [ATTR_VALUE_CREATE](undefined, { lang, data }) {
    try {
      const response = await attributeValueCreate(lang, data);
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  },
  async [ATTR_VALUE_UPDATE](undefined, { id, lang, data }) {
    try {
      const response = await attributeValueUpdate(id, lang, data);
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  },
  async [ATTR_VALUE_DELETE](undefined, { id }) {
    try {
      const response = await attributeValueDelete(id);
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
